var _path, _path2, _path3, _circle, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 37,
    viewBox: "0 0 154 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_288)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0171 36.3711C12.0171 24.3547 23.7257 12.6461 35.7421 12.6461V24.3547H23.7257V36.3711H12.0171Z",
    fill: "url(#paint0_linear_103_288)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7421 12.6461C20.5841 14.4268 18.8889 27.9148 18.8889 36.3711H23.725V24.3547H35.7414V12.6461H35.7421Z",
    fill: "url(#paint1_linear_103_288)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19,
    d: "M35.7421 12.7465V12.6453C20.5841 14.426 18.8889 27.914 18.8889 36.3704H19.6452C19.6452 28.0563 21.2837 14.8808 35.7414 12.7458L35.7421 12.7465Z",
    fill: "url(#paint2_linear_103_288)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0775 12.6591C20.0132 14.4883 18.3248 27.9332 18.3248 36.3711H18.8897C18.8897 27.9141 20.5842 14.4268 35.7428 12.6461C35.5213 12.6461 35.2997 12.6515 35.0781 12.6591H35.0775Z",
    fill: "url(#paint3_linear_103_288)",
    style: {
      mixBlendMode: "overlay"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.725 0.628967C23.725 12.646 12.0164 24.354 0 24.354V12.6453H12.0171V0.628967H23.7257H23.725Z",
    fill: "url(#paint4_linear_103_288)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24.354C15.1579 22.5733 16.8532 9.08598 16.8532 0.628967H12.0171V12.646H0V24.3547V24.354Z",
    fill: "url(#paint5_linear_103_288)",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.46,
    d: "M0 24.2535V24.3547C15.1579 22.5733 16.8532 9.08598 16.8532 0.628967H16.0968C16.0961 8.94305 14.4577 22.1185 0 24.2535Z",
    fill: "url(#paint6_linear_103_288)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M0.664689 24.341C15.7296 22.5124 17.418 9.06683 17.418 0.628967H16.8532C16.8532 9.08598 15.1579 22.5733 0 24.354C0.221563 24.354 0.443126 24.3485 0.664689 24.341Z",
    fill: "url(#paint7_linear_103_288)"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7667,
    cy: 6.32782,
    r: 1.88116,
    fill: "#F17732"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9196 18H52.4875L51.5971 15.3978H46.825L45.9346 18H42.589L47.3437 5.12752H51.1648L55.9196 18ZM50.7931 13.0377L49.2111 8.42128L47.629 13.0377H50.7931ZM74.752 5.12752L70.0577 18H66.3404L61.6461 5.12752H65.1301L68.2423 14.1702L71.3545 5.12752H74.752ZM91.2243 18H81.9136V5.12752H91.2243V7.61729H85.216V9.83907H90.792V12.3288H85.216V15.5102H91.2243V18ZM111.034 18H107.835L102.371 9.16476V18H99.3281V5.12752H103.296L107.99 12.5017V5.12752H111.034V18ZM126.849 9.06966C126.849 8.74691 126.783 8.47027 126.65 8.23974C126.517 8.0092 126.29 7.82766 125.967 7.6951C125.742 7.60289 125.48 7.54813 125.18 7.53084C124.881 7.50779 124.532 7.49626 124.134 7.49626H122.933V10.9629H123.953C124.483 10.9629 124.927 10.937 125.284 10.8851C125.641 10.8333 125.941 10.7151 126.183 10.5307C126.414 10.352 126.581 10.1561 126.685 9.94281C126.794 9.72381 126.849 9.43276 126.849 9.06966ZM132.027 18H127.973L124.463 13.2798H122.933V18H119.63V5.12752H125.198C125.958 5.12752 126.612 5.17075 127.16 5.2572C127.708 5.34365 128.22 5.53096 128.699 5.81912C129.183 6.10729 129.566 6.48191 129.849 6.94298C130.137 7.39829 130.281 7.97174 130.281 8.66335C130.281 9.6143 130.059 10.3895 129.615 10.9889C129.177 11.5883 128.549 12.0868 127.731 12.4845L132.027 18ZM150.687 18H147.255L146.364 15.3978H141.592L140.702 18H137.356L142.111 5.12752H145.932L150.687 18ZM145.56 13.0377L143.978 8.42128L142.396 13.0377H145.56ZM51.0633 34H49.7795V29.2733H44.962V34H43.6782V24.3456H44.962V28.1322H49.7795V24.3456H51.0633V34ZM60.0239 34H53.6633V24.3456H60.0239V25.4868H54.9471V28.1322H60.0239V29.2733H54.9471V32.8589H60.0239V34ZM69.6782 34H68.3101L67.3635 31.3092H63.1879L62.2413 34H60.9381L64.4523 24.3456H66.164L69.6782 34ZM66.968 30.207L65.2757 25.4673L63.577 30.207H66.968ZM77.2513 34H71.1436V24.3456H72.4273V32.8589H77.2513V34ZM84.3186 25.4868H80.8692V34H79.5854V25.4868H76.1361V24.3456H84.3186V25.4868ZM93.0004 34H91.7166V29.2733H86.8992V34H85.6154V24.3456H86.8992V28.1322H91.7166V24.3456H93.0004V34ZM107.725 33.2998C107.487 33.4035 107.271 33.5007 107.077 33.5915C106.887 33.6823 106.636 33.7774 106.325 33.8768C106.061 33.9589 105.773 34.0281 105.462 34.0843C105.155 34.1448 104.816 34.1751 104.444 34.1751C103.744 34.1751 103.106 34.0778 102.532 33.8833C101.961 33.6845 101.464 33.3754 101.04 32.9561C100.625 32.5455 100.301 32.0246 100.068 31.3935C99.8343 30.7581 99.7176 30.0211 99.7176 29.1825C99.7176 28.3872 99.83 27.6761 100.055 27.0494C100.28 26.4226 100.604 25.8931 101.027 25.4609C101.438 25.0416 101.933 24.7217 102.512 24.5013C103.096 24.2808 103.742 24.1706 104.451 24.1706C104.969 24.1706 105.486 24.2333 106 24.3586C106.519 24.484 107.094 24.7044 107.725 25.02V26.5436H107.628C107.096 26.0984 106.569 25.7742 106.046 25.5711C105.523 25.3679 104.963 25.2663 104.366 25.2663C103.878 25.2663 103.437 25.3463 103.044 25.5062C102.655 25.6618 102.307 25.9061 102 26.2389C101.702 26.5631 101.468 26.9737 101.3 27.4708C101.135 27.9636 101.053 28.5342 101.053 29.1825C101.053 29.8612 101.144 30.4447 101.326 30.9332C101.511 31.4216 101.749 31.8193 102.039 32.1262C102.341 32.4461 102.694 32.6838 103.096 32.8394C103.502 32.9907 103.93 33.0663 104.379 33.0663C104.998 33.0663 105.577 32.9604 106.117 32.7486C106.657 32.5368 107.163 32.2191 107.634 31.7955H107.725V33.2998ZM115.901 34H109.541V24.3456H115.901V25.4868H110.824V28.1322H115.901V29.2733H110.824V32.8589H115.901V34ZM125.309 34H123.721L119.143 25.3636V34H117.944V24.3456H119.934L124.11 32.2299V24.3456H125.309V34ZM134.762 25.4868H131.313V34H130.029V25.4868H126.58V24.3456H134.762V25.4868ZM142.42 34H136.059V24.3456H142.42V25.4868H137.343V28.1322H142.42V29.2733H137.343V32.8589H142.42V34ZM152.45 34H150.784L147.555 30.1616H145.746V34H144.462V24.3456H147.166C147.75 24.3456 148.236 24.3845 148.625 24.4623C149.014 24.5358 149.364 24.6698 149.675 24.8643C150.025 25.0848 150.298 25.3636 150.492 25.7008C150.691 26.0336 150.79 26.4572 150.79 26.9716C150.79 27.6675 150.615 28.251 150.265 28.7222C149.915 29.189 149.433 29.5413 148.819 29.7791L152.45 34ZM149.448 27.0623C149.448 26.7857 149.399 26.5415 149.299 26.3297C149.204 26.1136 149.044 25.932 148.819 25.785C148.633 25.6597 148.413 25.5732 148.158 25.5257C147.903 25.4738 147.603 25.4479 147.257 25.4479H145.746V29.0918H147.043C147.449 29.0918 147.804 29.0572 148.106 28.988C148.409 28.9145 148.666 28.7806 148.878 28.586C149.072 28.4045 149.215 28.197 149.306 27.9636C149.401 27.7259 149.448 27.4254 149.448 27.0623Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_288",
    x1: 36.4157,
    y1: 13.3203,
    x2: 12.6907,
    y2: 37.0454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FFA26D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_288",
    x1: 23.5452,
    y1: 21.5934,
    x2: 35.792,
    y2: 31.0618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFBB94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_288",
    x1: 23.0152,
    y1: 21.183,
    x2: 30.1702,
    y2: 26.7153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57A463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD770"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_103_288",
    x1: 15.2366,
    y1: 33.2829,
    x2: 35.8078,
    y2: 12.7117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FFA673"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_103_288",
    x1: 5.56575,
    y1: 17.4411,
    x2: 29.2908,
    y2: -6.28462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_103_288",
    x1: 5.5719,
    y1: 10.2847,
    x2: 12.7269,
    y2: 15.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F74F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_103_288",
    x1: 12.7269,
    y1: 15.817,
    x2: 5.5719,
    y2: 10.2847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E32A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4146C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#595EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6F74F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F74F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_103_288",
    x1: 20.5055,
    y1: 3.71717,
    x2: -0.0656515,
    y2: 24.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.7421,
    height: 35.7421,
    fill: "white",
    transform: "translate(0 0.628967)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d7cda77686cd38deb9e79db756cd8d4a.svg";
export { ForwardRef as ReactComponent };